import { ResponseLog } from "../../../models/logging/responseLog";

export const responseLogMapper = (response: Response | undefined) => {
  if (!response) {
    return response;
  }

  return {
    ok: response.ok,
    redirected: response.redirected,
    status: response.status,
    statusText: response.statusText,
    type: response.type as string,
    url: response.url,
  } as ResponseLog;
};
